import customSelect from '../customSelect';
import activeTrigger from '../../helpers/activeTrigger';
import { overviewInProgramFinder } from '../acalog/modules/overviewInProgramFinder';

export default ($) => {
  const goals = $('[data-goal]');
  const goalsSelect = $('select[name="goalSelect"]');
  const filterGoals = $('.js-goalFilter');
  const toggleFilters = $('.toggle-filters');
  const contentBox = $('#content-box');
  const filtersBox = $('#filters-box');
  const url = new URL(window.location);
  const goalIdParam = url.searchParams.get('goalId');
  let initializedActiveFilters = getFiltersFromQueryParams();
  let isProgrammaticChange = false;

  if (!goals.length) return;

  async function fetchDegrees() {
    if (isProgrammaticChange) {
      isProgrammaticChange = false;
      return;
    }

    let _this = $(this);
    let ID;

    if (_this.is('select')) {
      ID = _this.val();
    } else if (_this.is('[data-goal]')) {
      ID = _this.data('goal');

      isProgrammaticChange = true;
      goalsSelect.val(ID).change();
    }

    if (ID) {
      url.searchParams.set('goalId', ID);
      window.history.pushState({}, '', url);
    }

    const { ajaxurl } = wp_params;

    if (!ID) {
      console.error("No ID provided for the profile popup.");
      return;
    }

    try {
      const response = await $.ajax({
        url: ajaxurl,
        type: 'POST',
        data: {
          action: 'load_degrees',
          goalId: ID
        }
      });

      const { html, degrees } = response?.data;

      contentBox.html(html);

      if (degrees.length === 1) {
        const degreeId = degrees[0].id;
        const $degreeItem = $(`[data-degree-id="${degreeId}"]`);
        $degreeItem.addClass('-active');
      }

      generateFilters(degrees);
      overviewInProgramFinder();

      if (initializedActiveFilters) {
        preselectFilters(degrees);
        initializedActiveFilters = null;
      }

      customSelect($);
      activeTrigger();

      filterGoals.removeClass('hidden');
      toggleFilters.removeClass('hidden');
    } catch (error) {
      console.error("Error loading profile popup:", error);
    }
  }

  function generateFilters(degrees) {
    filtersBox.find('._programFinder__left__filter:not(.js-goalFilter)').remove();

    const filters = {
      degree_types: new Set(),
      preferred_learning: new Set(),
      locations: new Set(),
      area_of_study: new Set(),
      credentials: new Set()
    };

    degrees.forEach(degree => {
      if (degree.locations) {
        degree.locations.forEach(location => filters.locations.add(location));
      }

      if (degree.area_of_study) {
        degree.area_of_study.forEach(aos => filters.area_of_study.add(aos));
      }

      if (degree.credentials) {
        degree.credentials.forEach(cred => filters.credentials.add(cred));
      }

      if (degree.degree_types) {
        degree.degree_types.forEach(dt => filters.degree_types.add(dt));
      }

      if (degree.preferred_learning) {
        degree.preferred_learning.forEach(pl => filters.preferred_learning.add(pl));
      }
    });

    if (filters?.locations?.size) renderCheckboxFilter('locations', 'Locations', filters.locations);
    if (filters?.credentials?.size) renderCheckboxFilter('credentials', 'Credentials', filters.credentials);
    if (filters?.degree_types?.size) renderCheckboxFilter('degree_types', 'Degree Types', filters.degree_types);
    if (filters?.preferred_learning?.size) renderCheckboxFilter('preferred_learning', 'Preferred Learning', filters.preferred_learning);
    if (filters?.area_of_study?.size) createFilterDropdown('area_of_study', 'Area of Study', filters.area_of_study);
    renderResetBtn();

    filtersBox.find('input[type="checkbox"], select').on('change', function () {
      applyFilters(degrees);
    });
  }

  function renderResetBtn() {
    const resetBtn = `
    <div class="_programFinder__left__filter field field__reset" style="padding-top: 0;">
      <a href="${window.location.origin + window.location.pathname}" class="js-filterReset resetBtn" style="font-weight: 600;" aria-label="Click to reset filters">
        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M13.4844 6.50022H13.75C14.1657 6.50022 14.5 6.16585 14.5 5.75022V1.75022C14.5 1.4471 14.3188 1.1721 14.0375 1.05647C13.7563 0.940849 13.4344 1.00335 13.2188 1.21897L11.9188 2.51897C9.1813 -0.184151 4.77192 -0.174776 2.05005 2.55022C-0.684326 5.2846 -0.684326 9.71585 2.05005 12.4502C4.78442 15.1846 9.21567 15.1846 11.95 12.4502C12.3407 12.0596 12.3407 11.4252 11.95 11.0346C11.5594 10.644 10.925 10.644 10.5344 11.0346C8.5813 12.9877 5.41567 12.9877 3.46255 11.0346C1.50942 9.08147 1.50942 5.91585 3.46255 3.96272C5.4063 2.01897 8.54692 2.0096 10.5032 3.93147L9.2188 5.21897C9.00317 5.4346 8.94067 5.75647 9.0563 6.03772C9.17192 6.31897 9.44692 6.50022 9.75005 6.50022H13.4844Z" fill="#005889"/>
        </svg>
        Reset
      </a>
    </div>`;

    filtersBox.append(resetBtn);
  }

  function renderCheckboxFilter(name, title, options) {
    const checkboxes = Array.from(options)
      .map(option => `
      <label>
        <input type="checkbox" name="${name}" value="${option}">
        ${option}
      </label>
    `).join('');

    const filterHTML = `
    <div class="_programFinder__left__filter -checkbox">
      <div class="_programFinder__left__filter__title _filterTitle">${title}</div>
      <div class="_programFinder__left__filter__item -checkbox__boxes">
        ${checkboxes}
      </div>
    </div>
  `;

    filtersBox.append(filterHTML);
  }

  function createFilterDropdown(name, title, options) {
    const dropdown = Array.from(options)
      .map(option => `<option value="${option}">${option}</option>`)
      .join('');

    const filterHTML = `
    <div class="_programFinder__left__filter -select">
      <div class="_programFinder__left__filter__title _filterTitle">${title}</div>
      <div class="_programFinder__left__filter__item">
        <select name="${name}" class="custom" style="display: none;">
          <option value="">Select ${title}</option>
          ${dropdown}
        </select>
      </div>
    </div>
  `;

    filtersBox.append(filterHTML);
  }

  function applyFilters(degrees) {
    $('.-active').removeClass('-active');

    const activeFilters = {
      degree_types: getCheckedValues('degree_types'),
      preferred_learning: getCheckedValues('preferred_learning'),
      locations: getCheckedValues('locations'),
      area_of_study: getDropdownValue('area_of_study'),
      credentials: getCheckedValues('credentials'),
    };

    updateQueryParams(activeFilters);

    degrees.forEach(degree => {
      let degreeMatches = false; // Flag to track if any program in this degree matches

      degree.programs.forEach(program => {
        let programMatches = true; // Assume program matches by default
        let programId = program.id;

        // Loop through all active filters
        for (let [filterName, filterValues] of Object.entries(activeFilters)) {
          if (filterValues.length > 0) {
            const programFilterValues = program[filterName];

            // Check if the program matches the current filter
            if (!programFilterValues || !filterValues.some(value => programFilterValues.includes(value))) {
              programMatches = false; // Mark the program as non-matching
              break; // Stop checking filters if one doesn't match
            }
          }
        }

        // Handle visibility of the program based on whether it matches
        if (programMatches) {
          $(`[data-program-id="${programId}"]`).show();
          degreeMatches = true; // Mark degree as matching if this program matches
        } else {
          $(`[data-program-id="${programId}"]`).hide();
        }
      });

      $(`[data-degree-id="${degree.id}"]`).toggle(degreeMatches);

      const visibleDegrees = $('[data-degree-id]:visible');
      if (visibleDegrees.length === 1) {
        const $degreeItem = visibleDegrees.first();
        $degreeItem.addClass('-active');
      }
    });
  }

  function getCheckedValues(filterName) {
    return filtersBox
      .find(`input[name="${filterName}"]:checked`)
      .map((_, checkbox) => checkbox.value)
      .get();
  }

  function getDropdownValue(filterName) {
    const value = filtersBox.find(`select[name="${filterName}"]`).val();
    return value ? [value] : [];
  }

  function getFiltersFromQueryParams() {
    const params = new URLSearchParams(window.location.search);
    const filters = {};

    // Extract filters from query parameters
    const filterKeys = ['degree_types', 'preferred_learning', 'locations', 'area_of_study', 'credentials'];

    filterKeys.forEach(key => {
      const paramValue = params.get(key);
      if (paramValue) {
        filters[key] = paramValue.split(',');  // Multiple values are separated by commas
      } else {
        filters[key] = [];
      }
    });

    return filters;
  }

  function preselectFilters(degrees) {
    // Pre-select checkboxes based on `initializedActiveFilters`
    let exists = false;
    if (!initializedActiveFilters) return;

    Object.keys(initializedActiveFilters).forEach(filterKey => {
      const filterValues = initializedActiveFilters[filterKey];

      if (filterKey === 'degree_types' || filterKey === 'preferred_learning' || filterKey === 'locations' || filterKey === 'credentials') {
        filterValues.forEach(value => {

          $(`input[name="${filterKey}"`)
            .filter(`[value="${value}"]`)
            .prop('checked', true);
        });
      }

      // For dropdowns, select the option if it matches
      if (filterKey === 'area_of_study') {
        filterValues.forEach(value => {
          $(`select[name="${filterKey}"`)
            .val(value)
            .trigger('change'); // Select matching option in dropdown
        });
      }
      exists = true;
    });

    if (exists) {
      applyFilters(degrees);
    }
  }

  function updateQueryParams(activeFilters) {
    const url = new URL(window.location);

    // Loop through each active filter and update the URL
    for (const [filterName, filterValues] of Object.entries(activeFilters)) {
      if (filterValues.length > 0) {
        // Set the filter in the URL with values joined by commas
        url.searchParams.set(filterName, filterValues.join(','));
      } else {
        // If no values are selected for the filter, remove the filter from the URL
        url.searchParams.delete(filterName);
      }
    }

    // Update the URL without reloading the page
    window.history.pushState({}, '', url);
  }

  goals.on('click', fetchDegrees);
  goalsSelect.on('change', fetchDegrees);

  $(document).ready(() => {
    if (goalIdParam) {
      goalsSelect.val(goalIdParam).change();
    }
  });
}